import React, { useEffect } from 'react';
import { Mail, CheckCircle, ArrowRight } from 'lucide-react';

const EmailConfirmation = ({ email, onContinue }) => {
  // Clear the flag when component unmounts
  useEffect(() => {
    return () => {
      // Clear the session storage when leaving this component
      sessionStorage.removeItem('justRegistered');
    };
  }, []);

  return (
    <div className="px-8 py-10 text-center">
      {/* Success Icon */}
      <div className="flex justify-center mb-6">
        <div className="bg-green-100 rounded-full p-4">
          <CheckCircle className="text-green-600" size={48} />
        </div>
      </div>

      <h2 className="text-2xl font-bold text-sws-navy mb-4">
        Check Your Email to Confirm
      </h2>

      <div className="mb-6">
        <p className="text-sws-slate mb-4">
          We've sent a confirmation email to:
        </p>
        <p className="font-medium text-sws-navy text-lg mb-4">
          {email || 'your email address'}
        </p>
        <p className="text-sws-slate text-sm">
          Please click the link in the email to activate your account and start your 14-day free trial.
        </p>
      </div>

      {/* Email Icon with Animation */}
      <div className="mb-8">
        <div className="inline-flex items-center justify-center bg-sws-purple bg-opacity-10 rounded-lg p-6">
          <Mail className="text-sws-purple animate-pulse" size={32} />
        </div>
      </div>

      {/* Important Information */}
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6 text-left">
        <h3 className="font-medium text-blue-900 mb-2 flex items-center">
          <Mail size={16} className="mr-2" />
          Didn't receive the email?
        </h3>
        <ul className="text-sm text-blue-800 space-y-1">
          <li>• Check your spam or junk folder</li>
          <li>• Make sure you entered the correct email address</li>
          <li>• Wait a few minutes and check again</li>
        </ul>
      </div>

      {/* Continue Button */}
      <button
        onClick={onContinue}
        className="w-full flex justify-center items-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-sws-navy hover:bg-sws-slate transition-colors"
      >
        Continue to Sign In
        <ArrowRight size={16} className="ml-2" />
      </button>

      {/* Additional Help */}
      <p className="text-xs text-sws-slate mt-6">
        Still having trouble? Contact support at{' '}
        <a href="mailto:support@getprofitclarity.com" className="text-sws-purple hover:text-sws-navy">
          support@getprofitclarity.com
        </a>
      </p>
    </div>
  );
};

export default EmailConfirmation;